import { render, staticRenderFns } from "./OverviewCourseTask.vue?vue&type=template&id=6ec50ff8&scoped=true&"
import script from "./OverviewCourseTask.vue?vue&type=script&lang=js&"
export * from "./OverviewCourseTask.vue?vue&type=script&lang=js&"
import style0 from "./OverviewCourseTask.vue?vue&type=style&index=0&id=6ec50ff8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec50ff8",
  null
  
)

export default component.exports